import { homeRoutes } from './homeRoutes';
import { moduleRoutes } from './moduleRoutes';
import { staffRoutes } from './staffRoutes';
import { teamRoutes } from './teamRoutes';

export const v2routes = [...homeRoutes, ...moduleRoutes, ...teamRoutes, ...staffRoutes];
